import { useState } from 'react'

/**
 * Genoprettelseskoderne, som de vises den ene gang de kan ses (beslutning 035).
 *
 * De gemmes hashet på serveren, præcis som en adgangskode, så systemet kan ikke
 * vise dem igen. Derfor er der både kopiér og udskriv her - og en knap man
 * aktivt skal trykke på for at komme videre, så listen ikke bliver klikket væk.
 */
export function RecoveryCodeList({
  codes,
  onDone,
  doneLabel = 'Jeg har gemt koderne'
}: {
  codes: string[]
  onDone?: () => void
  doneLabel?: string
}) {
  const [copied, setCopied] = useState(false)

  const text = codes.join('\n')

  async function copy() {
    try {
      await navigator.clipboard.writeText(text)
      setCopied(true)
    } catch {
      // Udklipsholderen kræver en sikker forbindelse og kan være slået fra.
      // Koderne står på skærmen, så det er ikke en blokerende fejl.
      setCopied(false)
    }
  }

  return (
    <div style={{ textAlign: 'left', marginTop: 18 }}>
      <div
        className="error-box"
        style={{ marginBottom: 14, background: '#ECFDF5', borderColor: '#A7F3D0', color: '#065F46' }}
      >
        To-faktor er slået til. Gem koderne herunder <strong>nu</strong> - de vises aldrig igen.
      </div>

      <p className="small muted" style={{ marginBottom: 10 }}>
        Hver kode virker én gang og lukker dig ind, hvis du mister telefonen. Skriv dem ud, eller læg dem i din
        adgangskodeboks - ikke på samme telefon som appen.
      </p>

      <ul
        style={{
          listStyle: 'none',
          padding: 14,
          margin: '0 0 14px',
          border: '1px solid var(--border)',
          borderRadius: 8,
          background: 'var(--surface-2, #F8FAFC)',
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: 8,
          fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
          fontSize: 15,
          letterSpacing: 1
        }}
      >
        {codes.map((code) => (
          <li key={code}>{code}</li>
        ))}
      </ul>

      <div className="row" style={{ gap: 8, marginBottom: 14 }}>
        <button type="button" className="btn btn--sm" onClick={() => void copy()}>
          {copied ? 'Kopieret' : 'Kopiér'}
        </button>
        <button type="button" className="btn btn--sm" onClick={() => window.print()}>
          Udskriv
        </button>
      </div>

      {onDone && (
        <button type="button" className="btn btn--primary" style={{ width: '100%' }} onClick={onDone}>
          {doneLabel}
        </button>
      )}
    </div>
  )
}
